import httpClient, { catchError } from '@emmacare/common/api/httpClient'

// store
import { setCompanyDiseases } from 'src/store/modules/company/diseases'

import { COMPANY_DISEASES } from 'src/utils/constants'

export const fetchCompanyDiseases =
  (config: any = {}) =>
  async (dispatch: any) => {
    const { query = {} } = config

    try {
      const { items = [] } = await httpClient.request({
        method: 'get',
        url: {
          pathname: COMPANY_DISEASES,
          query
        }
      })

      dispatch(setCompanyDiseases(items))
    } catch (err) {
      catchError(err)
    }
  }
